// Api
const API = {
  backend: '/api/v1',
  fastApi: 'https://api.museaccount.choosemuse.com/api/v1'
};

// Analytics
const ANALYTICS = {
  clevertapId: 'R95-RRR-WK5Z'
};

const CHARGEBEE = {
  site: 'choosemuse',
  publishableKey: 'live_icucdcqbLffYcdSCkpjngculcuZppq9bYUGUX',
};

// Error tracking
const SENTRY = {
  DSN: 'https://09fd71ee6c7d4a23acc80bf5e2541a19@sentry.io/1240549',
  environment: 'Production'
};

const CONNECT = {
  URL: 'https://museconnect.choosemuse.com/'
};

const MSWEB = {
  URL: 'https://www.meditationstudioapp.com'
};

const AUTH0 = {
  domain: 'login.choosemuse.com',
  clientId: 'iUilBtANxNpzcAltZzAX0lEvvD4nmtBv',
  audience: 'prod.choosemuse',
  connection: 'Username-Password-Authentication',
  configurationBaseUrl: 'https://cdn.auth0.com',
  namespace: 'https://ix.com'
};

const GTAG = {
  id: 'UA-117268682-4'
};

export default {
  API,
  AUTH0,
  ANALYTICS,
  CONNECT,
  MSWEB,
  SENTRY,
  CHARGEBEE,
  GTAG
};



// WEBPACK FOOTER //
// ./src/config/production.js